module.exports = __webpack_public_path__ + "static/media/pr.42b0ade2.svg";